module.exports = __webpack_public_path__ + "img/em-pros-02.3354c99e.png";